import { useHeaderHeight, useHeaderStickyTopApi } from '@bluheadless/ui-logic/src/providers/header'
import { useElementHeight } from '@bluheadless/ui-logic/src/hooks/useElementHeight'
import StickyHeadroom from '../sticky-headroom'
import { NoSsr } from '@mui/material'

const HeaderHeight = () => {
	const [{ ref: headerRef }, { setHeight }] = useHeaderHeight()
	useElementHeight({ selector: headerRef.current, onChange: setHeight })

	return null
}

const StickyHeadroomAutoHeight = ({ children, ...props }) => {
	const [{ ref: headerRef, height: headerHeight }] = useHeaderHeight()
	const { setStickyTop } = useHeaderStickyTopApi()

	return (
		<StickyHeadroom
			scrollHeight={headerHeight}
			height={headerHeight}
			onStickyTopChanged={setStickyTop}
			upTolerance={headerHeight / 2}
			{...props}
		>
			<div ref={headerRef}>{children}</div>
			<NoSsr>
				<HeaderHeight />
			</NoSsr>
		</StickyHeadroom>
	)
}

StickyHeadroomAutoHeight.propTypes = { ...StickyHeadroom.propTypes }

export default StickyHeadroomAutoHeight
